module.exports = __webpack_public_path__ + "img/Ellipse1.b3536295.png";